import React from 'react';
import { Link } from 'react-router-dom';
import BadgeStatus from '../../../atoms/BadgeStatus';
import { MessageComposition } from '../../../../types/communication';
import { ChannelTile } from '../composition/shared/channelVisuals';

const GroupModelsTab: React.FC<{ models: MessageComposition[] }> = ({ models }) => {
    if (!models.length) {
        return (
            <div className="rounded-xl border-2 border-dashed border-gray-200 dark:border-slate-700 p-6 text-center text-sm text-gray-500">
                Nenhuma composição neste grupo. Escolha o grupo na tela da composição, em Identificação.
            </div>
        );
    }
    return (
        <ul className="flex flex-col gap-1">
            {models.map((m) => (
                <li key={m.id}>
                    <Link
                        to={`/communication/message-composition/${m.id}`}
                        className="flex items-center gap-3 rounded-lg px-2 py-2 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                    >
                        <ChannelTile channel={m.channel} size="sm" />
                        <span className="flex-1 min-w-0">
                            <span className="block text-sm text-gray-800 dark:text-gray-100 truncate">{m.description || m.name}</span>
                            <span className="block text-[11px] font-mono text-gray-400 truncate">{m.name}</span>
                        </span>
                        <BadgeStatus color={m.status === 'ACTIVE' ? 'green' : 'red'} text={m.status === 'ACTIVE' ? 'Ativo' : 'Inativo'} />
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default GroupModelsTab;
